export default __webpack_public_path__ + "static/media/NIE_touchpoint_12.029f7b76.mp4";